import React from 'react'
import { Button } from '../../components/Button/Button'
import { Link } from 'react-router-dom'
import { Modal } from '../../components/Modal/Modal'

type ClientProfileNotAvailableModalProps = {
  onHide?: () => void
  show?: boolean
}

export const ClientProfileNotAvailableModal: React.FC<ClientProfileNotAvailableModalProps> = ({ onHide, show = false }) => {
  const header = <h3 className='w-100 text-center'>Client Profile</h3>
  const body = (
    <div className='text-center'>
      This feature allows you to automatically build and maintain Client Profiles with field level history of changes and updates.
      <p className='mt-2 mb-0'>To start trialing, please contact our Sales team.</p>
    </div>
  )
  const footer = (
    <>
      <Button variant={'primary'}>
        <Link
          to='https://www.zocks.io/upgrade-to-professional?utm_medium=zocks&utm_source=in-app&utm_campaign=clientprofile'
          target='_blank'
          rel='noopener noreferrer'
          className='zocks-text-white'
        >
          Contact us
        </Link>
      </Button>
    </>
  )
  return (
    <Modal
      className='client-profile-not-available-modal'
      show={show}
      header={header}
      body={body}
      footer={footer}
      showFooterActions={false}
      centered={true}
      onHide={onHide}
    />
  )
}
